"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a CLOSE_CLIENT request.
 */
var CloseClientRequest = /** @class */ (function () {
    /**
     * Create a new CloseClientRequest instance
     *
     * @param sessionID a session ID
     */
    function CloseClientRequest(sessionID) {
        this.sessionID = sessionID;
    }
    /**
     * Convert object to string
     *
     * @return a string representation of the CloseClientRequest
     */
    CloseClientRequest.prototype.toString = function () {
        return 'CloseClientRequest [' + this.sessionID + ']';
    };
    return CloseClientRequest;
}());
exports.CloseClientRequest = CloseClientRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/close-client-request.js
// module id = 1325
// module chunks = 0